import type { Component } from "vue"
import { defineAsyncComponent } from "vue"

/** Renderers for the shared block library (`@dk/theme`'s `blocks.ts`).
 *
 *  One registry, spread into every block host that opts into the shared set, so a
 *  `dk-text` renders identically on the PDP and in the cart drawer. Lazy like the
 *  hosts' own registries: a page pays only for the shared blocks a seller
 *  actually placed.
 *
 *  Spread FIRST in each host so a host keeps the last word — if a section ever
 *  needs its own take on a shared type, its entry wins rather than being
 *  shadowed by this one at a distance. */
export const sharedBlockRegistry: Record<string, Component> = {
  "dk-heading": defineAsyncComponent(() => import("./SharedHeading.vue")),
  "dk-text": defineAsyncComponent(() => import("./SharedText.vue")),
  "dk-image": defineAsyncComponent(() => import("./SharedImage.vue")),
  "dk-button": defineAsyncComponent(() => import("./SharedButton.vue")),
  "dk-divider": defineAsyncComponent(() => import("./SharedDivider.vue")),
  "dk-spacer": defineAsyncComponent(() => import("./SharedSpacer.vue")),
}
